/**
 * Guest checkout state persisted in sessionStorage.
 *
 * `hopp_guest_info` holds the phone-verified checkout identity
 * (sessionToken, name, email, phone) between the GuestCheckoutForm and the
 * payment step. It deliberately survives a dismissed Razorpay modal so the
 * guest can retry payment without re-doing OTP — but it must NEVER survive
 * a Clerk sign-out or account switch, or the next buyer on this tab inherits
 * the previous identity (stale name/phone on the ticket, no way to switch
 * accounts).
 */
export const GUEST_CHECKOUT_STORAGE_KEYS = [
  "hopp_guest_info",
  "hopp_pending_checkout",
] as const;

export function clearGuestCheckoutStorage(): void {
  if (typeof window === "undefined") return;
  try {
    for (const key of GUEST_CHECKOUT_STORAGE_KEYS) {
      sessionStorage.removeItem(key);
    }
  } catch {
    /* sessionStorage unavailable (SSR, some incognito modes) */
  }
}
